export default "__VITE_ASSET__23e0a7f2__"